module.exports = __webpack_public_path__ + "img/全面识别.da7f00e3.png";